import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Banner Service
 * Handles all banner-related API calls
 */
const bannerService = {
  getAllBanners: async () => {
    const response = await apiClient.post(API_ENDPOINTS.BANNER.GET_ALL);
    return response.data;
  },

  addBanner: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.BANNER.ADD, data);
    return response.data;
  },

  updateBanner: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.BANNER.UPDATE, data);
    return response.data;
  },

  deleteBanner: async (bannerId) => {
    const response = await apiClient.post(API_ENDPOINTS.BANNER.DELETE, { bannerId });
    return response.data;
  },
};

export default bannerService;

